<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
    background-image: url(assets/header.png);
    background-position: 50%;
    background-size: cover;
    min-height: 100vh;
}
#app {
  font-family: Montserrat,Helvetica Neue,Helvetica,Arial,sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f5;
}
::selection {
  background: rgb(3, 120, 166);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue